(function () {
  var cfg = window.__RHH_DEFER_APPS__ || {};
  if (cfg.designMode) return;

  var shop = cfg.shop || (window.Shopify && Shopify.shop) || "";
  var isHome = Boolean(cfg.home);
  var allowedScripts = typeof WeakSet === "function" ? new WeakSet() : null;
  var held = { gorgias: [], seal: [] };
  var unlocked = { gorgias: false, seal: false };

  function classify(url) {
    var value = String(url || "");
    if (/gorgias\.chat/i.test(value)) return "gorgias";
    if (/sealsubscriptions|seal-subscription/i.test(value)) return "seal";
    return null;
  }

  function shouldHold(kind) {
    if (unlocked[kind]) return false;
    if (kind === "gorgias") return true;
    if (kind === "seal" && isHome) return true;
    return false;
  }

  function remember(kind, url) {
    if (held[kind].indexOf(url) === -1) held[kind].push(url);
  }

  function isAllowed(script) {
    return Boolean(
      (allowedScripts && allowedScripts.has(script)) ||
        (script && script.getAttribute && script.getAttribute("data-rhh-allow") === "1")
    );
  }

  function holdSrc(script, url) {
    if (isAllowed(script)) return false;
    var kind = classify(url);
    if (!kind || !shouldHold(kind)) return false;
    remember(kind, String(url));
    script.setAttribute("data-rhh-held", kind);
    return true;
  }

  var srcDescriptor = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "src");
  if (srcDescriptor && srcDescriptor.set) {
    Object.defineProperty(HTMLScriptElement.prototype, "src", {
      configurable: true,
      enumerable: srcDescriptor.enumerable,
      get: srcDescriptor.get,
      set: function (value) {
        if (holdSrc(this, value)) return;
        srcDescriptor.set.call(this, value);
      },
    });
  }

  var originalSetAttribute = HTMLScriptElement.prototype.setAttribute;
  HTMLScriptElement.prototype.setAttribute = function (name, value) {
    if (String(name).toLowerCase() === "src" && holdSrc(this, value)) return;
    return originalSetAttribute.apply(this, arguments);
  };

  function inject(url) {
    return new Promise(function (resolve) {
      if (!url) {
        resolve();
        return;
      }
      var script = document.createElement("script");
      if (allowedScripts) allowedScripts.add(script);
      script.setAttribute("data-rhh-allow", "1");
      script.async = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        resolve();
      };
      script.src = url;
      document.head.appendChild(script);
    });
  }

  function whenUserWayReady() {
    return new Promise(function (resolve) {
      var tries = 0;
      (function wait() {
        var api = window.UserWay;
        if (api && typeof api.widgetOpen === "function") {
          resolve(api);
          return;
        }
        if (++tries > 50) {
          resolve(api || null);
          return;
        }
        setTimeout(wait, 100);
      })();
    });
  }

  function loadUserWay() {
    if (loadUserWay.promise) return loadUserWay.promise;
    loadUserWay.promise = new Promise(function (resolve) {
      if (window.UserWay && typeof window.UserWay.widgetOpen === "function") {
        whenUserWayReady().then(resolve);
        return;
      }
      var script = document.createElement("script");
      if (allowedScripts) allowedScripts.add(script);
      script.setAttribute("data-rhh-allow", "1");
      script.setAttribute("data-account", cfg.userwayAccount || "bYoFPhTpDo");
      script.async = true;
      script.onload = function () {
        whenUserWayReady().then(resolve);
      };
      script.onerror = function () {
        resolve(null);
      };
      script.src = "https://cdn.userway.org/widget.js";
      (document.body || document.head).appendChild(script);
    });
    return loadUserWay.promise;
  }

  function openUserWay() {
    loadUserWay().then(function (api) {
      if (!api) return;
      if (typeof api.widgetOpen === "function") api.widgetOpen();
      if (typeof api.iconVisibilityOff === "function") {
        setTimeout(function () {
          api.iconVisibilityOff();
        }, 50);
      }
    });
  }

  function gorgiasLoaderUrl() {
    if (held.gorgias.length) return held.gorgias[0];
    return cfg.gorgiasLoader || "";
  }

  function whenGorgiasReady() {
    return new Promise(function (resolve) {
      function finish() {
        var api = window.GorgiasChat;
        if (!api) {
          resolve(null);
          return;
        }
        var started = typeof api.init === "function" ? api.init() : null;
        Promise.resolve(started).then(function () {
          resolve(window.GorgiasChat || api);
        });
      }

      if (window.GorgiasChat) {
        finish();
        return;
      }
      window.addEventListener("gorgias-widget-loaded", finish, { once: true });
    });
  }

  function hideDefaultGorgiasLauncher() {
    var frame = document.getElementById("chat-button");
    if (frame) frame.style.display = "none";
  }

  function loadGorgias() {
    if (loadGorgias.promise) return loadGorgias.promise;
    unlocked.gorgias = true;
    loadGorgias.promise = inject(gorgiasLoaderUrl()).then(whenGorgiasReady).then(function (api) {
      hideDefaultGorgiasLauncher();
      return api;
    });
    return loadGorgias.promise;
  }

  function toggleGorgias() {
    loadGorgias().then(function (api) {
      if (!api) return;
      if (typeof api.isOpen === "function" && api.isOpen()) {
        if (typeof api.close === "function") api.close();
        return;
      }
      if (typeof api.open === "function") api.open();
    });
  }

  function loadSeal() {
    if (!isHome) return Promise.resolve();
    if (loadSeal.promise) return loadSeal.promise;
    unlocked.seal = true;
    var stamp = Math.floor(Date.now() / 1000);
    loadSeal.promise = inject(
      "https://app.sealsubscriptions.com/shopify/public/status/shop/" + shop + ".js?" + stamp
    ).then(function () {
      var updated = window.sealsubscriptions_settings_updated || "default-by-script";
      var locale = (window.Shopify && Shopify.locale) || "";
      return inject(
        "https://cdn-app.sealsubscriptions.com/shopify/public/js/sealsubscriptions-main.js?shop=" +
          shop +
          "&" +
          updated +
          "&locale=" +
          locale
      );
    });
    return loadSeal.promise;
  }

  function loadSealAndBundler() {
    return loadSeal();
  }

  function createMobileChatButton() {
    if (!window.matchMedia("(max-width: 1023px)").matches) return;
    if (document.getElementById("custom-gorgias-chat-button")) return;
    if (document.body && document.body.classList.contains("rhh-landing-page")) return;

    var button = document.createElement("button");
    button.id = "custom-gorgias-chat-button";
    button.type = "button";
    button.setAttribute("aria-label", "Open chat");
    var stickySpacer = document.querySelector(".m-mobile-sticky-bar__spacer");
    if (stickySpacer) {
      button.style.cssText = [
        "position:absolute",
        "left:50%",
        "top:50%",
        "transform:translate(-50%,-50%)",
        "width:44px",
        "height:44px",
        "border-radius:50%",
        "background-color:#FFFFFF",
        "display:flex",
        "align-items:center",
        "justify-content:center",
        "border:none",
        "cursor:pointer",
        "z-index:1",
        "bottom:auto",
        "right:auto",
      ].join(";");
    } else {
      button.style.cssText = [
        "position:fixed",
        "bottom:10px",
        "left:50%",
        "transform:translateX(-50%)",
        "width:44px",
        "height:44px",
        "border-radius:50%",
        "background-color:#FFFFFF",
        "display:flex",
        "align-items:center",
        "justify-content:center",
        "border:none",
        "cursor:pointer",
        "z-index:1002",
      ].join(";");
    }
    button.innerHTML =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="#000000" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 4.713 6.926L6 19.897l2.968-2.039C9.960 17.944 10.969 18 12 18c5.514 0 10-3.589 10-8s-4.486-8-10-8zm0 14c-4.411 0-8-2.691-8-6s3.589-6 8-6 8 2.691 8 6-3.589 6-8 6z"/><circle cx="12" cy="10" r="1.5"/><circle cx="16" cy="10" r="1.5"/><circle cx="8" cy="10" r="1.5"/></svg>';
    if (stickySpacer) stickySpacer.appendChild(button);
    else document.body.appendChild(button);
  }

  function eventElement(event) {
    var node = event.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    return node;
  }

  document.addEventListener(
    "click",
    function (event) {
      var node = eventElement(event);
      if (!node || !node.closest) return;
      var userway = node.closest(
        'a[href="#userway-trigger"], a[href*="userway-trigger"], a[data-uw-original-href*="userway-trigger"], .m-header__accessibility, #accessibilityWidget'
      );
      if (userway) {
        event.preventDefault();
        event.stopPropagation();
        openUserWay();
        return;
      }
      if (node.closest("[data-gorgias-header-trigger], #custom-gorgias-chat-button")) {
        event.preventDefault();
        toggleGorgias();
      }
    },
    true
  );

  document.addEventListener("keydown", function (event) {
    if (event.target && event.target.id === "accessibilityWidget" && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      openUserWay();
    }
  });

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(createMobileChatButton);
  document.addEventListener("shopify:section:load", createMobileChatButton);

  window.__rhhDeferredApps = {
    loadUserWay: loadUserWay,
    openUserWay: openUserWay,
    loadGorgias: loadGorgias,
    toggleGorgias: toggleGorgias,
    loadSeal: loadSeal,
    loadSealAndBundler: loadSealAndBundler,
  };
})();
